import { funEU } from "../../../../utils/firebase"
import { AI_TOOLS } from "./registry"

/**
 * Run the email classifier against a single communication using the
 * **canonical** registry defaults — model, prompts, taxonomy, vision flag.
 *
 * The panel uses localStorage-persisted edits when running in "experiment"
 * mode; this helper deliberately ignores those overrides so production flows
 * (the per-row Re-classify button, future cron-based bulk classification)
 * always use the same vetted prompts.
 *
 * Resolves to whatever the callable returns:
 *   { output_text, parsed, model_used, usage, images_attached, saved_to_communication }
 */
export async function runClassifierWithDefaults(commId) {
	const tool = AI_TOOLS.classifier
	if (!tool) throw new Error("Classifier tool not registered")

	const customVariables = {}
	for (const input of tool.custom_inputs || []) {
		const value = input.default
		if (input.type === "list" && Array.isArray(value)) {
			customVariables[input.key] = value.join(", ")
		} else {
			customVariables[input.key] = String(value ?? "")
		}
	}

	const callable = funEU.httpsCallable("runEmailAiTool")
	const response = await callable({
		comm_id: commId,
		model: tool.default_model,
		temperature: tool.default_temperature,
		system_instructions: tool.default_system_instructions,
		user_instructions: tool.default_user_instructions,
		response_format: tool.response_format,
		json_schema: tool.json_schema,
		json_schema_name: tool.json_schema_name,
		json_schema_strict: tool.json_schema_strict,
		custom_variables: customVariables,
		pass_images: tool.pass_images === true,
		pass_external_images: tool.pass_external_images === true,
		include_inline_images: tool.include_inline_images === true,
		include_attachment_images: tool.include_attachment_images === true,
		include_file_attachments: tool.include_file_attachments === true,
		save_classification: true,
	})

	return response.data || null
}
